export default class TrayectoriaURGraph{

  constructor($scope,$uiGridConstants,$http,perfilSrv, $cookies,ngNotify, UserInfoConstant, $stateParams, $state){
    this.$scope = $scope;
    this.perfilSrv = perfilSrv;
    this.$cookies = $cookies;
    this.ngNotify = ngNotify;
    this.$http = $http;
    this.$uiGridConstants = $uiGridConstants;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.$scope.UserInfoConstant = UserInfoConstant;

    this.$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
      if (details !== undefined) {
        this.userinfo = details.user;
        this.userinfo.role_id = this.$cookies.get('hasRoleId');
        this.main();
      }
    });
  }

  main() {
    /**
    * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
    **/
    if (this.$stateParams.teacherId != '') {
      this.userinfo.teacherId = this.$stateParams.teacherId;
      this.getChartData(this.userinfo.teacherId);
    } else {
      this.perfilSrv.role.getType({param1: this.userinfo.role_id}).$promise.then((response) => {
        if (!response.status) {
          this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
        } else {
          this.role = response.data[0];
          if (this.role.types == 'TEACHER') {
            this.getInfo();
          }
        }
      }, (err) => {
        this.ngNotify.set('Imposible conectar con el servicio', 'error');
      });
    }
  }

  getInfo() {
    this.perfilSrv.role.getInfo({param1: this.userinfo.id}).$promise.then((response) => {
      if (!response.status) {
        this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
      } else {
        this.userinfo.teacherId = response.data[0].idTeacher;
        this.getChartData(this.userinfo.teacherId);
      }
    }, (err) => {
      this.ngNotify.set('Imposible conectar con el servicio', 'error');
    });
  }
  
  getChartData(teacherId) {
    this.perfilSrv.perfildocente.TrayectoriaURGraph({teacherId: teacherId}).$promise.then((response) => {   
      this.$scope.names = response.data;
      this.sigleName = this.$scope.names[0] || {};
    }, (data) => {
      this.ngNotify.set('Imposible conectar con el servicio', 'error');  
    });
  }
}

TrayectoriaURGraph.$inject = ['$scope','uiGridConstants','$http','perfilSrv','$cookies','ngNotify', 'UserInfoConstant', '$stateParams', '$state'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/UR_trajectory/TrayectoriaURGraph.js